import { render, staticRenderFns } from "./PerfilComentarios.vue?vue&type=template&id=ffb5dedc"
import script from "./PerfilComentarios.vue?vue&type=script&lang=js"
export * from "./PerfilComentarios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports